import { __awaiter, __decorate } from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, _GraphQueryableInstance, _GraphQueryableCollection, graphInvokableFactory, } from "../graphqueryable.js";
import { assign, combine, safeGlobal } from "@pnp/common";
import { defaultPath, getById, deleteable, updateable } from "../decorators.js";
import { body, BlobParser } from "@pnp/odata";
import { graphPatch, graphPut } from "../operations.js";
/**
 * Describes a Drive instance
 *
 */
let _Drive = class _Drive extends _GraphQueryableInstance {
    get root() {
        return Root(this);
    }
    get list() {
        return this.clone(GraphQueryableInstance, "list");
    }
    get recent() {
        return DriveItems(this, "recent");
    }
    get sharedWithMe() {
        return DriveItems(this, "sharedWithMe");
    }
    getItemById(id) {
        return DriveItem(this, combine("items", id));
    }
};
_Drive = __decorate([
    defaultPath("drive")
], _Drive);
export { _Drive };
export const Drive = graphInvokableFactory(_Drive);
/**
 * Describes a collection of Drive objects
 *
 */
let _Drives = class _Drives extends _GraphQueryableCollection {
};
_Drives = __decorate([
    defaultPath("drives"),
    getById(Drive)
], _Drives);
export { _Drives };
export const Drives = graphInvokableFactory(_Drives);
/**
 * Describes a Root instance
 *
 */
let _Root = class _Root extends _GraphQueryableInstance {
    get children() {
        return DriveItems(this, "children");
    }
    search(query) {
        const searcher = this.clone(Root);
        searcher.query.set("search", `'${query}'`);
        return searcher();
    }
    get thumbnails() {
        return this.clone(GraphQueryableCollection, "thumbnails");
    }
};
_Root = __decorate([
    defaultPath("root")
], _Root);
export { _Root };
export const Root = graphInvokableFactory(_Root);
/**
 * Describes a Drive Item instance
 *
 */
let _DriveItem = class _DriveItem extends _GraphQueryableInstance {
    get children() {
        return DriveItems(this, "children");
    }
    get thumbnails() {
        return this.clone(GraphQueryableCollection, "thumbnails");
    }
    get versions() {
        return this.clone(GraphQueryableCollection, "versions");
    }
    move(parentReference, name) {
        return graphPatch(this, body(assign(parentReference, { name })));
    }
    getContent() {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this.get();
            const r = yield safeGlobal.fetch(info["@microsoft.graph.downloadUrl"], {
                headers: {
                    "accept": "application/json",
                },
                method: "GET",
                responseType: "arraybuffer",
            });
            const p = new BlobParser();
            return p.parse(r);
        });
    }
    setContent(content) {
        return graphPut(this.clone(DriveItem, "content"), {
            body: content,
        });
    }
};
_DriveItem = __decorate([
    deleteable(),
    updateable()
], _DriveItem);
export { _DriveItem };
export const DriveItem = graphInvokableFactory(_DriveItem);
/**
 * Describes a collection of Drive Item objects
 *
 */
let _DriveItems = class _DriveItems extends _GraphQueryableCollection {
};
_DriveItems = __decorate([
    getById(DriveItem)
], _DriveItems);
export { _DriveItems };
export const DriveItems = graphInvokableFactory(_DriveItems);
//# sourceMappingURL=types.js.map